import * as Lens from ".";
import * as Getter from "../getter";
import * as Setter from "../setter";
export const compose_ = (l1, l2) => Lens.lens(Getter.compose(l1, l2), Setter.compose(l1, l2));
export function compose(f, ...fs) {
    return fs.reduce((f1, f2) => compose_(f1, f2), f);
}

